<template>
    <div>
        <div class="info">
            <p>Please fill out the attached examination request form carefully and send it by e-mail along with a copy of the patient's passport.</p>
            <p>예약을 위해 아래 첨부된 검진의뢰서를 꼼꼼히 작성하시어 환자의 여권사본과 함께 메일로 보내주세요.</p>
            <div class="botton-wrap"><a href="/document-download-pdf.do?name=Request_form.xlsx" class="main-button c-main" title="동의서 다운로드"><span class="icon"><img src="/img/download.a49d337a.svg" alt=""></span>Request form</a></div>
        </div>
        <div class="info">
            <h3 class="bullet01">Contact</h3>
            <p class="bullet03 depth">eumcint@gmail.com (Contact Hours : 09:00 ~ 16:45)</p>
            <p class="bullet03 depth">02-6986-3100​</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>